import React, { createContext, useState, useContext } from 'react';

interface AppContextType {
  appTitle: string;
  setAppTitle: (title: string) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [appTitle, setAppTitle] = useState('Slide Master');

  const setAppTitleDelayed = (title: string) => {
    setTimeout(() => {
      setAppTitle(title);
    }, 10);
  };

  return (
    <AppContext.Provider value={{ appTitle, setAppTitle: setAppTitleDelayed }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
